import { useState } from "react"

export const DeliveryState = () => {
    const [isLoader, setIsLoader] = useState(false)
    const [viewLoader, setViewLoader] = useState(false)
    const [orderlist, setOrderList] = useState([])
    const [action, setAction] = useState([])
    const [isConfirm, setIsConfirm] = useState(false)
    const [search, setSearch] = useState('')
    const [inftSrcoll, setInftScroll] = useState(false)
    const [lid, setLid] = useState(0)
    const [driverInfo, setDriverInfo] = useState({name: '', contact_no: '', remarks:''})
    const [msg, setMsg] = useState('')
    const [err, setErr] = useState(false)
    const [payBalForm, setPayBalForm] = useState({modal: false, mode_payment: '', payment_channel: '', bal_payment: '', payment_ref: '', btnLoader: false, confirmation: false, error: false})
    const [payChannel, setPayChannel] = useState([])
    // training {loader: false, list: []}
    const [trainingSales, setTrainingSales] = useState([])
    const [total, setTotal] = useState(0)
    const [loader, setLoader] = useState(false)
    const [trainingSaleView, setTrainingSaleView] = useState({loader: false, open: false, info: {} })
    const [filter, setFilter] = useState({training_id: '', from: '', to: '', search: ''})
    const [allTraining, setAllTraining] = useState([])
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
	// membership
	const [mbrshpModal, setMbrshpModalModal] = useState(false)
	const [mbrshpDetails, setMbrshpDetail] = useState({ id: '', data: {}, mid: '', inclusions: [], validity: 0 })
	const [mbrshpList, setMbrshpList] = useState([])
	const [mbrshpLoader, setMbrshpLoader] = useState({ view: false, init: false })
	const [mbrshpFilter, setMbrshpFilter] = useState({ membership_id: 'All', from: '', to: '', search: '' })
	const [mbrshpRegistrants, setMbrshpRegistrants] = useState([])
	const [mbrshpHasMore, setMbrshpHasMore] = useState(true)
	const [mbrshpPage, setMbrshpPage] = useState(1)
    
    return {
        isLoader: { data: isLoader, set: setIsLoader },
        viewLoader: { data: viewLoader, set: setViewLoader },
        orderlist: { data: orderlist, set: setOrderList },
        action: { data: action, set: setAction },
        isConfirm: { data: isConfirm, set: setIsConfirm },
        search: { data: search, set: setSearch },
        inftSrcoll: { data: inftSrcoll, set: setInftScroll },
        lid: { data: lid, set: setLid },
        driverInfo: { data: driverInfo, set: setDriverInfo },
        msg: { data: msg, set: setMsg },
        err: { data: err, set: setErr },
        payBalForm: { data: payBalForm, set: setPayBalForm },
        payChannel: { data: payChannel, set: setPayChannel },
        // training
        trainingSales: { data: trainingSales, set: setTrainingSales },
        total: { data: total, set: setTotal },
        loader: { data: loader, set: setLoader },
        trainingSaleView: { data: trainingSaleView, set: setTrainingSaleView },
        filter: { data: filter, set: setFilter },
        allTraining: { data: allTraining, set: setAllTraining },
        page: { data: page, set: setPage },
        hasMore: { data: hasMore, set: setHasMore },
		// membership
		mbrshpModal: { data: mbrshpModal, set: setMbrshpModalModal },
		mbrshpDetails: { data: mbrshpDetails, set: setMbrshpDetail },
		mbrshpList: { data: mbrshpList, set: setMbrshpList },
		mbrshpLoader: { data: mbrshpLoader, set: setMbrshpLoader },
		mbrshpFilter: { data: mbrshpFilter, set: setMbrshpFilter },
		mbrshpRegistrants: { data: mbrshpRegistrants, set: setMbrshpRegistrants },
        mbrshpHasMore: { data: mbrshpHasMore, set: setMbrshpHasMore },
		mbrshpPage: { data: mbrshpPage, set: setMbrshpPage },
    }
}
